import { Component, Input } from '@angular/core';
import { from, of, Subscription } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';

@Component({
  selector: 'app-rapi-loader',
  templateUrl: './rapi-loader.component.html',
  styleUrls: ['./rapi-loader.component.css'],
})
export class RapiLoaderComponent {
  messages: string[] = [
    'Estamos procesando tu solicitud.',
    'Solicitud en proceso, gracias por la espera.',
    '¡Faltan pocos segundos!',
  ];
  currentMessage: string = '';
  private _status: boolean;
  private messageSubs: Subscription;

  constructor() {}

  get status() {
    return this._status;
  }

  @Input()
  set status(status: boolean) {
    this._status = status;
    if (this._status) {
      this.messageSubs = from(this.messages)
        .pipe(concatMap((item) => of(item).pipe(delay(3000))))
        .subscribe((message) => {
          this.currentMessage = message;
        });
    } else {
      this.messageSubs?.unsubscribe();
      this.currentMessage = null;
    }
  }
}
